import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
  useMultiStyleConfig,
} from '@chakra-ui/react'
import { getName } from '~/utils/objectUtils'

const DeleteButtonParts = ['iconButton', 'icon'] as const

const helpers = createMultiStyleConfigHelpers(DeleteButtonParts)
export const DeleteButtonStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    iconButton: {
      background: 'transparent',
      _active: {
        background: 'transparent',
        '& > svg': {
          color: 'red.900',
        },
      },
    },
    icon: {
      color: 'gray.900',
      boxSize: '2rem',
      transition: 'color 0.5s ease-in',
    },
  },
})

export const useDeleteButtonStyle = (props?: StyleThemingProps) => {
  return useMultiStyleConfig(
    getName({ DeleteButtonStyle }),
    props,
  ) as MultiStyleType<typeof DeleteButtonParts>
}
